import React from "react";

function CostPerCallIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#37367D" rx="5"></rect>
            <path
                fill="#fff"
                d="M32.435 31.42a2.166 2.166 0 00-2.645 1.21 4.662 4.662 0 00-.071.178c-2.88-1.231-5.29-3.64-6.52-6.52.06-.023.119-.046.178-.072a2.169 2.169 0 001.21-2.645C22.158 16 22.094 16 21.314 16A5.321 5.321 0 0016 21.315c0 10.306 8.385 18.692 18.691 18.692a5.321 5.321 0 005.316-5.316c0-.78 0-.843-7.572-3.27zM29.49 20.287a6.236 6.236 0 016.229 6.229.857.857 0 101.715 0c0-4.38-3.564-7.944-7.944-7.944a.857.857 0 100 1.715z"
            ></path>
            <path
                fill="#fff"
                d="M28.006 24.137a3.871 3.871 0 013.866 3.866.857.857 0 101.715 0 5.587 5.587 0 00-5.581-5.581.857.857 0 100 1.715z"
            ></path>
        </svg>
    );
}

export default CostPerCallIcon;
